<template>
  <div :id="uploadId" class="fm-uplaod-container">
    <draggable
      :no-transition-on-drag="true"
      class="drag-img-list"
      v-bind="{group: uploadId, ghostClass: 'ghost', animation: 200}"
      v-model="fileList"
    >
      <div
        :class="{uploading: item.status=='uploading', 'is-success': item.status=='success', 'is-diabled': disabled}"
        :id="item.key"
        :key="item.key"
        :style="{width: width+'px', height: height+'px'}"
        class="upload-file"
        v-for="(item) in fileList"
      >
        <img :src="item.url" />

        <a-progress
          :percent="item.percent"
          :width="50"
          class="upload-progress"
          type="circle"
          v-if="item.status=='uploading'"
        />

        <label class="item-status" v-if="item.status=='success'">
          <i class="el-icon-upload-success el-icon-check" />
        </label>

        <div :style="{height: miniWidth / 4 + 'px'}" class="uplaod-action" v-if="!disabled">
          <i
            :style="{'font-size': miniWidth/8+'px'}"
            :title="$t('fm.upload.preview')"
            @click="handlePreviewFile(item.key)"
            class="iconfont icon-tupianyulan"
          />
          <i
            :style="{'font-size': miniWidth/8+'px'}"
            :title="$t('fm.upload.edit')"
            @click="handleEdit(item.key)"
            class="iconfont icon-sync1"
            v-if="isEdit"
          />
          <i
            :style="{'font-size': miniWidth/8+'px'}"
            :title="$t('fm.upload.delete')"
            @click="handleRemove(item.key)"
            class="iconfont icon-delete"
            v-if="isDelete && fileList.length > min"
          />
        </div>
      </div>
    </draggable>

    <div
      :class="{'is-disabled': disabled}"
      :style="{width: width+'px', height: height+'px'}"
      @click.self="handleAdd"
      class="ant-upload ant-upload-select ant-upload-select-picture-card"
      v-if="!preview"
      v-show="showPreview"
    >
      <i
        :style="{fontSize:miniWidth/4+'px',marginTop: (-miniWidth/8)+'px', marginLeft: (-miniWidth/8)+'px'}"
        @click.self="handleAdd"
        class="anticon anticon-plus"
      >
        <svg
          aria-hidden="true"
          class
          data-icon="plus"
          fill="currentColor"
          focusable="false"
          height="1em"
          viewBox="64 64 896 896"
          width="1em"
        >
          <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" />
          <path d="M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z" />
        </svg>
      </i>
      <input
        :style="{width: 0, height: 0}"
        @change="handleChange"
        accept="image/*"
        class="a-upload__input upload-input"
        multiple
        name="file"
        ref="uploadInput"
        type="file"
        v-if="multiple"
      />
      <input
        :style="{width:0, height: 0}"
        @change="handleChange"
        accept="image/*"
        class="a-upload__input upload-input"
        name="file"
        ref="uploadInput"
        type="file"
        v-else
      />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Viewer from 'viewerjs'
  import Draggable from 'vuedraggable'
  import * as qiniu from 'qiniu-js'
  require('viewerjs/dist/viewer.css')
  import { ACCESS_TOKEN } from '@/store/mutation-types'

  import VueI18n from 'vue-i18n'
  Vue.use(VueI18n)
  export default {
    components: {
      Draggable
    },
    name: 'ImgUpload',
    props: {
      value: {
        type: Array,
        default: () => []
      },
      width: {
        type: Number,
        default: 100
      },
      height: {
        type: Number,
        default: 100
      },
      token: {
        type: String,
        default: ''
      },
      domain: {
        type: String,
        default: ''
      },
      multiple: {
        type: Boolean,
        default: false
      },
      length: {
        type: Number,
        default: 9
      },
      isQiniu: {
        type: Boolean,
        default: false
      },
      isDelete: {
        type: Boolean,
        default: false
      },
      min: {
        type: Number,
        default: 0
      },
      meitu: {
        type: Boolean,
        default: false
      },
      isEdit: {
        type: Boolean,
        default: false
      },
      action: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      preview: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        fileList: this.value.map(item => {
          return {
            key: item.key ? item.key : (new Date().getTime()) + '_' + Math.ceil(Math.random() * 99999),
            url: item.url,
            percent: item.percent ? item.percent : 100,
            status: item.status ? item.status : 'success'
          }
        }),
        viewer: null,
        uploadId: 'upload_' + new Date().getTime(),
        editIndex: -1,
        meituIndex: -1
      }
    },
    computed: {
      miniWidth () {
        if (this.width > this.height) {
          return this.height
        } else {
          return this.width
        }
      },
      showPreview () {
        return (!this.isQiniu || (this.isQiniu && this.token)) && this.fileList.length < this.length
      }
    },
    watch: {
      'fileList': {
        deep: true,
        handler (val) {
          this.$emit('input', this.fileList)
        }
      }
    },
    mounted () {
      this.$emit('input', this.fileList)
    },
    methods: {
      handleChange () {
        const files = this.$refs.uploadInput.files

        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          const reader = new FileReader()
          const key = (new Date().getTime()) + '_' + Math.ceil(Math.random() * 99999)
          reader.readAsDataURL(file)
          reader.onload = () => {
            if (this.editIndex >= 0) {
              this.$set(this.fileList, this.editIndex, {
                key,
                url: reader.result,
                percent: 0,
                status: 'uploading'
              })

              this.editIndex = -1
            } else {
              this.fileList.push({
                key,
                url: reader.result,
                percent: 0,
                status: 'uploading'
              })
            }

            this.$nextTick(() => {
              if (this.isQiniu) {
                this.uplaodAction2(reader.result, file, key)
              } else {
                this.uplaodAction(reader.result, file, key)
              }
            })
          }
        }
        this.$refs.uploadInput.value = []
      },
      uplaodAction (res, file, key) {
        // eslint-disable-next-line no-unused-vars
        const changeIndex = this.fileList.findIndex(item => item.key === key)
        const xhr = new XMLHttpRequest()

        const url = window._CONFIG['domianURL'] + this.action
        xhr.open('POST', url, true)
        // xhr.setRequestHeader('Content-Type', 'multipart/form-data')
        // X-Access-Token:
        const token = Vue.ls.get(ACCESS_TOKEN)
        xhr.setRequestHeader('X-Access-Token', token)
        const formData = new FormData()
        formData.append('file', file)

        xhr.send(formData)
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            const response = Object.assign(xhr.response, { url: xhr.response.message })
            const resData = JSON.parse(response)
            var uploadUrl = resData.message
            // if (resData.url !== undefined && resData.url !== null && resData.url !== '') {
            //   uploadUrl = resData.url
            // } else if (resData.data !== undefined && resData.data !== null && resData.data !== '') {
            //   uploadUrl = resData.data
            // }
            if (uploadUrl) {
              this.$set(this.fileList, this.fileList.findIndex(item => item.key === key), {
                ...this.fileList[this.fileList.findIndex(item => item.key === key)],
                url: uploadUrl,
                percent: 100
              })
              setTimeout(() => {
                this.$set(this.fileList, this.fileList.findIndex(item => item.key === key), {
                  ...this.fileList[this.fileList.findIndex(item => item.key === key)],
                  status: 'success'
                })
                this.$emit('input', this.fileList)
              }, 200)
            } else {
              this.$set(this.fileList, this.fileList.findIndex(item => item.key === key), {
                ...this.fileList[this.fileList.findIndex(item => item.key === key)],
                status: 'error'
              })
              this.fileList.splice(this.fileList.findIndex(item => item.key === key), 1)
            }
          }
        }
        xhr.onprogress = (res) => {
          if (res.total && res.loaded) {
            this.$set(this.fileList[this.fileList.findIndex(item => item.key === key)], 'percent', res.loaded / res.total * 100)
          }
        }
      },
      uplaodAction2 (res, file, key) {
        const _this = this
        const observable = qiniu.upload(file, key, this.token, {
          fname: key,
          mimeType: []
        }, {
          useCdnDomain: true,
          region: qiniu.region.z2
        })
        observable.subscribe({
          next (res) {
            _this.$set(_this.fileList[_this.fileList.findIndex(item => item.key === key)], 'percent', parseInt(res.total.percent))
          },
          // eslint-disable-next-line handle-callback-err
          error (err) {
            _this.$set(_this.fileList, _this.fileList.findIndex(item => item.key === key), {
              ..._this.fileList[_this.fileList.findIndex(item => item.key === key)],
              status: 'error'
            })
            _this.fileList.splice(_this.fileList.findIndex(item => item.key === key), 1)
          },
          complete (res) {
            _this.$set(_this.fileList, _this.fileList.findIndex(item => item.key === key), {
              ..._this.fileList[_this.fileList.findIndex(item => item.key === key)],
              url: _this.domain + res.key,
              percent: 100
            })
            setTimeout(() => {
              _this.$set(_this.fileList, _this.fileList.findIndex(item => item.key === key), {
                ..._this.fileList[_this.fileList.findIndex(item => item.key === key)],
                status: 'success'
              })
              _this.$emit('input', _this.fileList)
            }, 200)
          }
        })
      },
      handleRemove (key) {
        this.fileList.splice(this.fileList.findIndex(item => item.key === key), 1)
      },
      handleEdit (key) {
        this.editIndex = this.fileList.findIndex(item => item.key === key)

        this.$refs.uploadInput.click()
      },
      handleMeitu (key) {
        this.$emit('on-meitu', this.fileList.findIndex(item => item.key === key))
      },
      handleAdd () {
        if (!this.disabled) {
          this.editIndex = -1
          this.$refs.uploadInput.click()
        }
      },
      handlePreviewFile (key) {
        this.viewer && this.viewer.destroy()
        this.uploadId = 'upload_' + new Date().getTime()

        this.$nextTick(() => {
          this.viewer = new Viewer(document.getElementById(this.uploadId))
          this.viewer.view(this.fileList.findIndex(item => item.key === key))
        })
      }
    }
  }
</script>

<style lang="less">
  .fm-uplaod-container {
    height: 100px;
    .is-disabled {
      position: relative;

      &::after {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        // background: rgba(0,0,0,.1);
        content: '';
        display: block;
        cursor: not-allowed;
      }
    }

    .upload-file {
      margin: 0 10px 10px 0;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      // background: #fff;
      overflow: hidden;
      background-color: #fff;
      border: 1px solid #c0ccda;
      border-radius: 6px;
      box-sizing: border-box;
      position: relative;
      vertical-align: top;
      &:hover {
        .uplaod-action {
          display: flex;
        }
      }
      .uplaod-action {
        position: absolute;
        // top: 0;
        // height: 30px;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
        display: none;
        justify-content: center;
        align-items: center;
        i {
          color: #fff;
          cursor: pointer;
          margin: 0 5px;
        }
      }
      &.is-success {
        .item-status {
          position: absolute;
          right: -15px;
          top: -6px;
          width: 40px;
          height: 24px;
          background: #13ce66;
          text-align: center;
          transform: rotate(45deg);
          box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);
          & > i {
            font-size: 12px;
            margin-top: 11px;
            color: #fff;
            transform: rotate(-45deg);
          }
        }
      }
      &.uploading {
        &:before {
          display: block;
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.3);
        }
      }
      .upload-progress {
        position: absolute;
        .a-progress__text {
          color: #fff;
          font-size: 16px !important;
        }
      }
      img {
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
      }
    }
    .ant-upload-select-picture-card {
      position: relative;
      overflow: hidden;
      .anticon-plus {
        position: absolute;
        top: 50%;
        left: 50%;
      }
    }
    .upload-input {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: block;
      opacity: 0;
      cursor: pointer;
    }

    .drag-img-list {
      display: inline;

      .ghost {
        position: relative;
        &::after {
          width: 100%;
          height: 100%;
          display: block;
          content: '';
          background: #fbfdff;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          border: 1px dashed #3bb3c2;
        }
      }

      & > div {
        cursor: move;
      }
    }
  }

  .viewer-container {
    z-index: 9999 !important;
  }
</style>
